import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const Unauthorized: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timeout = setTimeout(() => {
            navigate("/landing", { replace: true });
        }, 4000);

        return () => clearTimeout(timeout);
    }, [navigate]);


    return (
        <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
            <Header />

            <main className="flex-grow flex items-center justify-center px-4 text-center">
                <div className="max-w-md">
                    <h1 className="text-2xl font-bold text-red-600 mb-3">Access Denied</h1>
                    <p className="text-gray-700">
                        You don’t have permission to view this page.
                    </p>
                    <p className="text-gray-600 font-medium mt-4">
                        Redirecting you to the landing page...
                    </p>
                </div>
            </main>

            <Footer />
        </div>

    );
};

export default Unauthorized;
